(ns ncr.push
  (:require
   [cljs.core.async :as async :refer [<! >! alts!] :refer-macros [go go-loop]]
   [cljs.core.async.interop :refer-macros [<p!]]
   [clojure.string :as str]
   [taoensso.encore :as e]
   [com.rpl.specter :as sp]
   [lambdaisland.glogi :as log]
   [ncr.etc.util :as u]
   [haslett.client :as ws]
   [haslett.format :as fmt]
   [ncr.etc.pubsub :as ps]
   [ncr.sysinfo]
   [ncr.auth]))

#_(go
    (let [token (<! (ncr.auth/token))
          url (str "ws://localhost:8891/push/ws?access_token=" token)
          {:keys [sink source] :as ws} (<! (ws/connect url))]
      (>! sink "Hello World")
      (js/console.log (<! source))
      (ws/close ws)))

(defonce cluster-slug (atom nil))

(defn- cluster-channel [s]
  (str "/clusters/" s))

(defonce prev (atom nil))

(defn connect-effect-fn []
  (let [stop (async/chan)
        p @prev]
    (reset! prev stop)
    (some-> p async/close!)

    (go-loop []
      (e/cond
        :do (log/info :what ::connecting)
        :let [token (<! (ncr.auth/token))
              base js/self.location.origin

              url
              (str
                (str/replace base #"^http" "ws")
                "/push/ws?access_token="
                token)

              {:keys [sink source close-status] :as conn}
              (<! (ws/connect url {:format fmt/json}))]

        :do (log/info :what ::connected)
        :do (>! sink {:msg-type :subscribe :channel "/ping"})

        :do (when @cluster-slug
              (>! sink
                {:msg-type :subscribe
                 :channel (cluster-channel @cluster-slug)}))

        :do (add-watch cluster-slug ::watcher
              (fn [_ _ o n]
                (when (not= o n)
                  (when o
                    (async/put! sink
                      {:msg-type :unsubscribe
                       :channel (cluster-channel o)}))
                  (when n
                    (async/put! sink
                      {:msg-type :subscribe
                       :channel (cluster-channel n)})))))

        :let [rv
              (loop []
                (let [[v c] (alts! [source stop])]
                  (if (= c stop)
                    ::stopped
                    (let [{:keys [event-type] :as vp}
                          (when v
                            (->> v
                              e/keywordize-map
                              (sp/transform
                                (sp/multi-path
                                  (sp/must :event-type)
                                  (sp/must :domain))
                                keyword)))]
                      (if (some? vp)
                        (do
                          (when-not (= event-type :ping)
                            (log/debug :what ::message :details vp)
                            (ps/pub! [:push/message vp]))
                          (recur))

                        (do
                          (log/info
                            :what :disconnected :details (<! close-status))
                          ::closed))))))]

        ;:do (log/info :what ::connection :status rv)
        :do (remove-watch cluster-slug ::watcher)
        :do (ws/close conn)

        (= rv ::closed)
        (do
          (<! (async/timeout 2000))
          (recur))))
    #(async/close! stop)))

(def use-push!
  (partial ps/use-sub! :push/message))


